import React, { useEffect, useState, useMemo, useCallback } from "react";

import DatePicker, { registerLocale } from "react-datepicker";
import da from "date-fns/locale/da";
import "react-datepicker/dist/react-datepicker.css";

import addDays from "date-fns/addDays";
import addMonths from "date-fns/addMonths";

import { Steps } from 'rsuite';
import 'rsuite/dist/styles/rsuite-default.css'
import { isNull } from "util";

import img from "./MPmedium1x_2.png";


registerLocale("da", da);


const Wizard = (wizardStep: number) => {

    return (<Steps current={wizardStep}>
        <Steps.Item title="Dato" description=" " />
        <Steps.Item title="Reservation" description=" " />
        <Steps.Item title="Bekræft" description=" " />
        <Steps.Item title="Betal" description=" " />
    </Steps>);
}






//const Home = () => {
export default function Home() {
    useEffect(() => {
        checkAvailability();
    }, []);
    

    // Pricing
    const [priceWeekday, setPriceWeekday] = useState(600);
    const [priceWeekdayMorning, setPriceWeekdayMorning] = useState(200);
    const [priceWeekdayAfternoon, setPriceWeekdayAfternoon] = useState(200);
    const [priceWeekdayEvening, setPriceWeekdayEvening] = useState(200);
    const [priceFriday, setPriceFriday] = useState(1875);
    const [priceSaturday, setPriceSaturday] = useState(2250);
    const [priceSunday, setPriceSunday] = useState(750);
    const [priceShortWeekend, setPriceShortWeekend] = useState(2625);
    const [priceLongWeekend, setPriceLongWeekend] = useState(3000);
    const [priceCommercialMultiplier, setPriceCommercialMultiplier] = useState(3);

    const [price, setPrice] = useState(0);
    const [priceText, setPriceText] = useState("");

    const [startDate, setStartDate] = useState(new Date());
    const [startDate2, setStartDate2] = useState(addMonths(new Date(), -12));
    const [startDate3, setStartDate3] = useState(addMonths(new Date(), -12));
    const [excludedDates, setExcludedDates] = useState([new Date()]);
    const [excludedSlots, setExcludedSlots] = useState("");

    const [bookingOptions, setOptions] = useState("");
    const [selectedReservationType, setSelectedReservationType] = useState(0);

    const [hideDateSelection, setHideDateSelection] = useState(false);
    const [hideConfirmation, setHideConfirmation] = useState(true);
    const [hideReservationSelection, setHideReservationSelection] = useState(true);
    const [hideCompleteReservation, setHideCompleteReservation] = useState(true);
    const [discountText, setDiscountText] = useState("");

    //Input fields
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [address, setAddress] = useState("");
    const [title, setTitle] = useState("");
    const [regNo, setRegNo] = useState("");
    const [account, setAccount] = useState("");
    const [confirmTermsAndConditions, setConfirmTermsAndConditions] = useState(false);

    
    //Error codes
    const [nameErr, setNameErr] = useState("");
    const [emailErr, setEmailErr] = useState("");
    const [phoneErr, setPhoneErr] = useState("");
    const [addressErr, setAddressErr] = useState("");
    const [titleErr, setTitleErr] = useState("");
    const [regNoErr, setRegNoErr] = useState("");
    const [accountErr, setAccountErr] = useState("");
    const [confirmTermsAndConditionsErr, setConfirmTermsAndConditionsErr] = useState("");

    //Step Wizard
    const [wizardStep, setWizardStep] = useState(0);
    const styles = {
        width: '200px',
        display: 'inline-table',
        verticalAlign: 'center'
    };
    


    //Step 1=>2
    async function onChangeDate (date:any) {
        const start = date;
        
        setStartDate(start);
        setHideReservationSelection(false);
        setWizardStep(1);

        // Resetting other fields
        setHideConfirmation(true);
        setHideDateSelection(true);
        setHideCompleteReservation(true);
        setSelectedReservationType(0);

        // Hiding highlighted dates
        setStartDate2(addMonths(new Date(), -12));
        setStartDate3(addMonths(new Date(), -12));

        switch (start.getDay()) {
            case 0:
                // Sunday
                setOptions("47");
                return;
            case 5:
                // Friday

                var nextDay = addDays(new Date(Number(start.getFullYear()), Number(start.getMonth()) , Number(start.getDate())), 1);
                var nextNextDay = addDays(new Date(Number(start.getFullYear()), Number(start.getMonth()), Number(start.getDate())), 2);

                if ((!excludedDates.find(item => { return item.getTime() == nextNextDay.getTime() })) && (!excludedDates.find(item => { return item.getTime() == nextDay.getTime() }))) {
                    setOptions("267");
                } else {
                    setOptions("27");
                }
                return;
            case 6:
                // Saturday
                var nextDay = addDays(new Date(Number(start.getFullYear()), Number(start.getMonth()), Number(start.getDate())), 1);
                
                if (!excludedDates.find(item => { return item.getTime() == nextDay.getTime() })) {
                    setOptions("357");
                } else {
                    setOptions("37");
                }
                return;
            default:
                // Weekday

                //Check timeslot availability for date
                const response = await fetch('availability?startDate=' + start.getFullYear() + "-" + ('00' + (start.getMonth() + 1)).slice(-2) + "-" + ('00' + start.getDate()).slice(-2) + '&queryType=timeslots');
                const data = await response.json();
                var excludedSlots = data[0] + '';
                
                
                
                var options = "";
                if (excludedSlots == "000" || excludedSlots == '') {
                    options = "17890";
                } else {
                    if (excludedSlots.substring(0, 1) == "0") {
                        options = options + "8";
                    }
                    if (excludedSlots.substring(1, 2) == "0") {
                        options = options + "9";
                    }
                    if (excludedSlots.substring(2, 3) == "0") {
                        options = options + "0";
                    }
                }

                setOptions(options);

                return;
        }
    }
    //Step 2=>3
    function handleSelectReservationType(selectedType: number, selectedUse: string) {
        //setSelectedReservationType(changeEvent.target.value);
        setSelectedReservationType(selectedType);
        setHideConfirmation(false);
        setWizardStep(2);

        //Hide other selections
        setHideDateSelection(true);
        setHideReservationSelection(true);
        setHideCompleteReservation(true);


        var discountPct = 1;

        if (startDate <= new Date(2021, 11, 31)) {
            discountPct = 0.75;
            setDiscountText("Bemærk: 25% 'corona rabat' for reservationer i 2021");
        }


        switch (selectedType) {
            case 1:
                // Hverdagsleje
                if (selectedUse == "commercial") {
                    setPrice(priceWeekday * priceCommercialMultiplier * discountPct);
                } else {
                    setPrice(priceWeekday * discountPct);
                }
                setPriceText("Hverdag: 08:00 - 23:00")

                // Hiding highlighted dates
                setStartDate2(addMonths(new Date(), -12));
                setStartDate3(addMonths(new Date(), -12));
                return;
            case 2:
                // Fredagsleje
                setPrice(priceFriday * discountPct);
                setPriceText("Fredag kl 08:00 - Lørdag kl 09:30")
                // Hiding highlighted dates
                setStartDate2(addMonths(new Date(), -12));
                setStartDate3(addMonths(new Date(), -12));
                return;
            case 3:
                // Lørdagsleje
                setPrice(priceSaturday * discountPct);
                setPriceText("Lørdag kl 11:00 - Søndag kl 09:30")
                // Hiding highlighted dates
                setStartDate2(addMonths(new Date(), -12));
                setStartDate3(addMonths(new Date(), -12));
                return;
            case 4:
                // Søndagsleje
                setPrice(priceSunday * discountPct);
                setPriceText("Søndag kl 11:00 - 23:00")
                // Hiding highlighted dates
                setStartDate2(addMonths(new Date(), -12));
                setStartDate3(addMonths(new Date(), -12));
                return;
            case 5:
                // Kort weekend
                setPrice(priceShortWeekend * discountPct);
                setPriceText("Kort weekend: Lørdag kl 11:00 - Søndag kl 23:00")
                setStartDate2(addDays(startDate, 1));
                // Hiding highlighted dates
                setStartDate3(addMonths(new Date(), -12));

                return;
            case 6:
                // Lang weekend
                setPrice(priceLongWeekend * discountPct);
                setPriceText("Lang weekend: Fredag kl 11:00 - Søndag kl 23:00")
                setStartDate2(addDays(startDate, 1));
                setStartDate3(addDays(startDate, 2));
                return;
            case 7:
                // Offentligt arrangement
                setPrice(0);
                setPriceText("Offentligt arrangement")
                setStartDate2(addDays(startDate, -12));
                setStartDate3(addDays(startDate, -12));
                return;
            case 8:
                // Hverdagsleje, morgen
                if (selectedUse == 'commercial') {
                    setPrice(priceWeekdayMorning * priceCommercialMultiplier * discountPct);
                } else {
                    setPrice(priceWeekdayMorning * discountPct);
                }
                setPriceText("Hverdag: 08:00 - 12:00")

                // Hiding highlighted dates
                setStartDate2(addMonths(new Date(), -12));
                setStartDate3(addMonths(new Date(), -12));
                return;
            case 9:
                // Hverdagsleje, eftermiddag
                if (selectedUse == 'commercial') {
                    setPrice(priceWeekdayAfternoon * priceCommercialMultiplier * discountPct);
                } else {
                    setPrice(priceWeekdayAfternoon * discountPct);
                }
                setPriceText("Hverdag: 12:00 - 18:00")

                // Hiding highlighted dates
                setStartDate2(addMonths(new Date(), -12));
                setStartDate3(addMonths(new Date(), -12));
                return;
            case 0:
                // Hverdagsleje, aften
                if (selectedUse == 'commercial') {
                    setPrice(priceWeekdayEvening * priceCommercialMultiplier * discountPct);
                } else {
                    setPrice(priceWeekdayEvening * discountPct);
                }
                
                setPriceText("Hverdag: 18:00 - 23:00");

                // Hiding highlighted dates
                setStartDate2(addMonths(new Date(), -12));
                setStartDate3(addMonths(new Date(), -12));
                return;
            default:
                // no input
                setPrice(0);
                setPriceText("")
                setHideConfirmation(true);
                return;

        }
    }
    //Step 3=>4
    async function handleReservation(changeEvent: any) {
        changeEvent.preventDefault();

        var inputValid = true;
        setNameErr("");
        setEmailErr("");
        setPhoneErr("");
        setAddressErr("");
        setRegNoErr("");
        setAccountErr("");
        setAddressErr("");
        setConfirmTermsAndConditionsErr("");

        
        // Validate name
        if (!/^[ÆØÅæøåa-zA-Z]{1,}(?: [ÆØÅæøåa-zA-Z]+){1,6}$/.test(name.trim())) {
            inputValid = false;
            setNameErr("Indsæt for- og efternavn");
        }

        // Validate email
        const expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([\t]*\r\n)?[\t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([\t]*\r\n)?[\t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;

        if (!expression.test(email.trim())) {
            inputValid = false;
            setEmailErr("Ugyldig email");
        }

        // Validate phone
        if (!/[0-9]{8}/.test(phone)) {
            inputValid = false;
            setPhoneErr("8-cifret dansk telefonnr, uden mellemrum");
        }

        // Validate address
        if (!/^(mølletoften|møllen|frodes mark|annas have|baastrup lund|maries dal|einars lykke|ellens høj|smedeskovvej) [0-9]{1,3}$/.test(address.toLowerCase())) {
            inputValid = false;
            setAddressErr("Indtast vejnavn + husnr (i Skovby Nygaard)");
        }

        // Validate Title
        if (/[!@#$%^&*(),.?":{}|<>]/g.test(title)) {
            inputValid = false;
            setTitleErr("Specialtegn ikke tilladt");
        }

        // Validate regno
        if (!/[0-9]{4}$/.test(regNo)) {
            inputValid = false;
            setRegNoErr("Indtast 4 cifret reg no");
        }

        // Validate account no
        if (!/[0-9]{4,10}$/.test(account)) {
            inputValid = false;
            setAccountErr("Indtast 10 cifret konto no");
        }

        if (!confirmTermsAndConditions) {
            inputValid = false;
            setConfirmTermsAndConditionsErr("Ordensreglementet skal accepteres");
        }

        if (inputValid) {
            var dateInput = "";
            var eventType = "Private";
            // For Public (free) reservations
            if (selectedReservationType == 7) {
                eventType = "Public";
            } 

            //Setting reservation date information
            //Short Weekend (2 days)
            if (selectedReservationType == 5) {
                dateInput = '&date=' + startDate.getFullYear() + "-" + ('00' + (startDate.getMonth() + 1)).slice(-2) + "-" + ('00' + startDate.getDate()).slice(-2) +
                    '&date2=' + startDate2.getFullYear() + "-" + ('00' + (startDate2.getMonth() + 1)).slice(-2) + "-" + ('00' + startDate2.getDate()).slice(-2);

            //Long Weekend (3 days)
            } else if (selectedReservationType == 6) {
                dateInput = '&date=' + startDate.getFullYear() + "-" + ('00' + (startDate.getMonth() + 1)).slice(-2) + "-" + ('00' + startDate.getDate()).slice(-2) +
                    '&date2=' + startDate2.getFullYear() + "-" + ('00' + (startDate2.getMonth() + 1)).slice(-2) + "-" + ('00' + startDate2.getDate()).slice(-2) +
                    '&date3=' + startDate3.getFullYear() + "-" + ('00' + (startDate3.getMonth() + 1)).slice(-2) + "-" + ('00' + startDate3.getDate()).slice(-2);

            //All other reservation types
            } else {
                dateInput = '&date=' + startDate.getFullYear() + "-" + ('00' + (startDate.getMonth() + 1)).slice(-2) + "-" + ('00' +startDate.getDate()).slice(-2);
            }


            // Determine timeslot type (full/partial day)
            var timeSlot = "full";
            if (selectedReservationType == 8) {
                timeSlot = "morning";
            } else if (selectedReservationType == 9) {
                timeSlot = "afternoon";
            } else if (selectedReservationType == 0) {
                timeSlot = "evening";
            }

            // Send reservation request to backend
            const response = await fetch('reservation?name=' + name + dateInput + '&price=' + price + '&email=' + email +
                '&phone=' + phone + '&address=' + address + '&title=' + title + '&account=' + account + '&regno=' + regNo + '&eventType=' + eventType + '&timeSlot=' + timeSlot);

            // Handle error response
            const data = await response.json();
            if (data[0] != "200") {
                alert("Fejl under reservering");
            } else {
                setWizardStep(4);
                setHideCompleteReservation(false);
                setHideConfirmation(true);
            }



            checkAvailability();
        }


    }
    //Step 4=>1
    function resetReservationDetails() {
        setStartDate(new Date());
        setStartDate2(addMonths(new Date(), -12));
        setStartDate3(addMonths(new Date(), -12));
        setOptions("");
        setPrice(0);
        setPriceText("");
        setSelectedReservationType(0);
        setDiscountText("");

        
        setHideDateSelection(false);
        setHideReservationSelection(true);
        setHideConfirmation(true);
        setHideCompleteReservation(true);
        setWizardStep(0);

        //Input fields
        setName("");
        setEmail("");
        setPhone("");
        setAddress("");
        setTitle("");
        setRegNo("");
        setAccount("");
        setConfirmTermsAndConditions(false);
    }


    function ValidatePhoneInput(e: any){
        var val = e.target.value;
        val = val.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
        setPhone(val);
    }

    function ValidateRegNoInput(e: any) {
        var val = e.target.value;
        val = val.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
        setRegNo(val);
    }

    function ValidateAccountInput(e: any) {
        var val = e.target.value;
        val = val.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
        setAccount(val);
    }

    async function checkAvailability() {
        const response = await fetch('availability?startDate=' + startDate.getFullYear() + "-" + ('00' + (startDate.getMonth() + 1)).slice(-2) + "-" + ('00' + startDate.getDate()).slice(-2));
        const data = await response.json();

        //Cycle input dates and convert to Date elements
        var dates:Date[] = [];
        for (let i = 0; i < data.length; i++) {
            if (data[i] != null) {
                var indexOfFirst = data[i].indexOf("-");
                var indexOfSecond = data[i].indexOf("-", (indexOfFirst + 1));
                
                var year = data[i].substring(0, 4);
                var month = data[i].substring(indexOfFirst + 1, indexOfSecond) - 1;
                var day = data[i].substring(indexOfSecond + 1, data[i].length);
                
                dates = dates.concat(new Date(year, month, day));
            }
            
        }

        /* Example adding blocked days "manually"
         * dates = dates.concat(new Date(2022, 0, 17));
         */

        setExcludedDates(dates);
    }

    
    return (

        <div>
            <meta content="yes" name="apple-mobile-web-app-capable" />
            <meta content="minimum-scale=1.0, width=device-width, maximum-scale=1, user-scalable=no" name="viewport" />

            <h3>Reservering af fælleshus</h3>
            <div hidden={window.innerWidth >= 700}>
                <br /><br /><br />
                {Wizard(wizardStep)}
            </div>
            <div className="split">  
            <div className="fixedWidth">
                <table >
                    <tr hidden={hideDateSelection}>
                    
                        <br />
                            <br />
                            <h4>1. Vælg ledig dato:</h4>

                            <DatePicker
                                onChange={onChangeDate}
                                startDate={startDate}
                                excludeDates={excludedDates}
                                minDate={addDays(new Date(), 1)}
                                maxDate={addDays(new Date(), 1827)}
                                showDisabledMonthNavigation
                                formatWeekDay={nameOfDay => nameOfDay.substr(0, 3)}
                                locale='da'
                                inline />
                            

                        </tr>
                        
                    <tr hidden={hideReservationSelection}>
                        <br />
                        <br />
                            <h4>2. Vælg reservations mulighed</h4>
                            Start dato :<strong> {!!(startDate) ? startDate.getDate() + "." + (startDate.getMonth() + 1) + "." + startDate.getFullYear() : 'Vælg start dato'}</strong><br />
                            <br/>
                            <table className="options">
                        
                            <tr>
                                <th>Reservations type</th>
                                <th>Privat brug</th>
                                <th title="Arrangementer med brugerbetaling">Kommercielt brug</th>
                            </tr>
                            <tr  hidden={bookingOptions.includes("1") ? false : true} >
                                <td><strong>Hele dagen:</strong> 08:00 - 23:00</td>
                                <td><button className="btn btn-primary btn-sm" onClick={() => handleSelectReservationType(1, "")}>{priceWeekday},-</button></td>
                                <td><button className="btn btn-primary btn-sm" onClick={() => handleSelectReservationType(1, "commercial")}>{priceWeekday * priceCommercialMultiplier},-</button></td>
                            </tr>
                            <tr  hidden={bookingOptions.includes("8") ? false : true}>
                                <td><strong>Formiddag:</strong> 08:00 - 12:00</td>
                                <td><button className="btn btn-primary btn-sm" onClick={() => handleSelectReservationType(8, "")}>{priceWeekdayMorning},-</button></td>
                                <td><button className="btn btn-primary btn-sm" onClick={() => handleSelectReservationType(8, "commercial")}>{priceWeekdayMorning * priceCommercialMultiplier},-</button></td>
                            </tr>
                            <tr hidden={bookingOptions.includes("9") ? false : true}>
                                <td><strong>Eftermiddag:</strong> 12:00 - 18:00</td>
                                <td><button className="btn btn-primary btn-sm" onClick={() => handleSelectReservationType(9, "")}>{priceWeekdayAfternoon},-</button></td>
                                <td><button className="btn btn-primary btn-sm" onClick={() => handleSelectReservationType(9, "commercial")}>{priceWeekdayAfternoon * priceCommercialMultiplier},-</button></td>
                            </tr>
                            <tr  hidden={bookingOptions.includes("0") ? false : true}>
                                <td><strong>Aften:</strong> 18:00 - 23:00</td>
                                <td><button className="btn btn-primary btn-sm" onClick={() => handleSelectReservationType(0, "")}>{priceWeekdayEvening},-</button></td>
                                <td><button className="btn btn-primary btn-sm" onClick={() => handleSelectReservationType(0, "commercial")}>{priceWeekdayEvening * priceCommercialMultiplier},-</button></td>
                            </tr>
                            <tr onClick={() => handleSelectReservationType(2, "")} hidden={bookingOptions.includes("2") ? false : true} >
                                <td><strong>Fredag</strong> kl 08:00 - Lørdag kl 09:30</td>
                                <td><button className="btn btn-primary btn-sm" onClick={() => handleSelectReservationType(2, "")}>{priceFriday},-</button></td>
                                <td>-</td>
                            </tr>
                            <tr onClick={() => handleSelectReservationType(3, "")} hidden={bookingOptions.includes("3") ? false : true} >
                                    <td><strong>Lørdag</strong> kl 11:00 - Søndag kl 09:30</td>
                                <td><button className="btn btn-primary btn-sm" onClick={() => handleSelectReservationType(3, "")}>{priceSaturday},-</button></td>
                                <td>-</td>
                            </tr>
                            <tr onClick={() => handleSelectReservationType(4, "")} hidden={bookingOptions.includes("4") ? false : true} >
                                <td><strong>Søndag</strong> kl 11:00 - 23:00</td>
                                <td><button className="btn btn-primary btn-sm" onClick={() => handleSelectReservationType(4, "")}>{priceSunday},-</button></td>
                                <td>-</td>
                            </tr>
                            <tr onClick={() => handleSelectReservationType(5, "")} hidden={bookingOptions.includes("5") ? false : true} >
                                <td><strong>Kort weekend:</strong> Lørdag kl 11:00 - Søndag kl 23:00</td>
                                <td><button className="btn btn-primary btn-sm" onClick={() => handleSelectReservationType(5, "")}>{priceShortWeekend},-</button></td>
                                <td>-</td>
                            </tr>
                            <tr onClick={() => handleSelectReservationType(6, "")} hidden={bookingOptions.includes("6") ? false : true} >
                                <td><strong>Lang weekend:</strong> Fredag kl 11:00 - Søndag kl 23:00</td>
                                <td><button className="btn btn-primary btn-sm" onClick={() => handleSelectReservationType(6, "")}>{priceLongWeekend},-</button></td>
                                <td>-</td>
                            </tr>
                            <tr onClick={() => handleSelectReservationType(7, "")} hidden={bookingOptions.includes("7") ? false : true} >
                                <td><strong>Offentligt Arrangement </strong> (Hele dagen)<br/> Alle foreningsmedlemmer velkommen</td>
                                <td><button className="btn btn-primary btn-sm" onClick={() => handleSelectReservationType(7, "")}>0,-</button></td>
                                <td>-</td>
                            </tr>
                            
                            </table>
                            <br/>
                            <button
                                className="btn btn-primary btn-lg"
                                onClick={resetReservationDetails}>
                                {"Annuller"}</button>
                    </tr>
                    <tr hidden={ hideConfirmation }>
                        <br />
                        <br />
                        <h4>3. Bekræft reservation</h4>
                        Reservation: <strong>{priceText}</strong><br/>
                        Start dato :<strong> {!!(startDate) ? startDate.getDate() + "." + (startDate.getMonth()+1) + "." + startDate.getFullYear() : 'Vælg start dato'}</strong><br />
                            
                            <p>Prisen for din reservationen bliver: kr. <strong>{price}</strong></p>
                            <i className="redText">{discountText}</i><br/><br/>

                        <table>
                            <tr>
                                <td>Dit fulde navn:</td>
                                <td>
                                    <input type="text" placeholder="fulde navn" value={name} onChange={e => setName(e.target.value)}></input>
                                    {nameErr.length > 0 && (
                                        <span className="error">{nameErr}</span>)}
                                </td>
                            </tr>
                            <tr>
                                <td>Din email adresse:</td>
                                <td>
                                    <input type="text" placeholder="email" value={email} onChange={e => setEmail(e.target.value)}></input>
                                    {emailErr.length > 0 && (
                                        <span className="error">{emailErr}</span>)}
                                </td>
                            </tr>
                            <tr>
                                <td>Dit mobiltelefon nr:</td>
                                <td>
                                    <input type="text" placeholder="mobiltelefon nr" value={phone} maxLength={8} onChange={ValidatePhoneInput}></input>
                                    {phoneErr.length > 0 && (
                                    <span className="error">{phoneErr}</span>)}
                                </td>
                            </tr>
                            <tr>
                                <td>Din adresse: </td>
                                <td>
                                    <input type="text" placeholder="vejnavn + husnr" value={address} onChange={e => setAddress(e.target.value)}></input>
                                    {addressErr.length > 0 && (
                                        <span className="error">{addressErr}</span>)}
                                </td>
                            </tr>
                            <tr>
                                <td>Arrangementets titel: </td>
                                    <td><input type="text" placeholder="fx. 40-års fødselsdag" value={title} onChange={e => setTitle(e.target.value)}></input>
                                        {titleErr.length > 0 && (
                                            <span className="error">{titleErr}</span>)}
                                </td>
                            </tr>
                            <tr>
                                <td>Registrerings nummer: </td>
                                <td>
                                    <input name="regNo" type="text" value={regNo} onChange={ValidateRegNoInput} maxLength={4} />
                                    {regNoErr.length > 0 && (
                                        <span className="error">{regNoErr}</span>)}
                                </td>
                            </tr>
                            <tr>
                                <td>Konto nr:</td>
                                <td><input type="text" value={account} onChange={ValidateAccountInput} maxLength={10} />
                                    {accountErr.length > 0 && (
                                        <span className="error">{accountErr}</span>)}
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>
                                        <input onClick={() => setConfirmTermsAndConditions(!confirmTermsAndConditions)} checked={confirmTermsAndConditions} type="checkbox" />
                                        Jeg bekræfter at have læst Ordensreglementet og Regler for booking (<a href="http://skovbynygaardgrund.dk/faelleshus/regler-faelleshuset/" target="_blank">link</a>), samt lover at overholde de gældende retningslinjer for brug af fælleshuset.
                                        {confirmTermsAndConditionsErr.length > 0 && (
                                            <span className="error">{confirmTermsAndConditionsErr}</span>)}
                                    </td>
                                </tr>
                        </table>
                        <br/>
                            <button
                                className="btn btn-primary btn-lg"
                                onClick={handleReservation}>
                                {"Reserver"}</button>
                            &nbsp;&nbsp;&nbsp;
                            <button
                                className="btn btn-primary btn-lg"
                                onClick={resetReservationDetails}>
                                {"Annuller"}</button>
                        </tr>

                        <tr hidden={hideCompleteReservation}>
                            <br />
                            <br />
                            <div>
                                <h4>Tillykke, {name}!</h4>
                                <p>Du har nu reserveret Fælleshuset fra den. {startDate.getDate() + "." + (startDate.getMonth() + 1) + "." + startDate.getFullYear()}</p>
                                <p><em>({priceText})</em></p>
                                <p>Vi har sendt en bekræftigelse til addressen: {email}</p>
                                <br/>
                                <div hidden={price == 0}>
                                    <div hidden={ true }>
                                        <p>Bemærk: du skal inden for 10 dage betale depositum på kr. 1000, for at fastholde reservationen.</p>
                                        <p>Dette beløb vil blive refunderet efter lejemålets afslutning</p>
                                    </div>
                                    <p>Lejebeløbet på kr. {price} skal senest være betalt 30 dage inden lejens start.</p>
                                    <hr />
                                    <p >Beløb indbetales til reg.nr. 6114 kontonr. 13661898<br />
                                    Tilføj posterings teksten: "{startDate.getDate() + "." + (startDate.getMonth() + 1) + "." + startDate.getFullYear()} - {address}"</p>
                                    <br />
                                    
                                    <p>Eller betal med Mobilepay <br /></p>
                                    <a href={"https://www.mobilepay.dk/erhverv/betalingslink/betalingslink-svar?phone=576306&amount=" + price + " &comment=" + startDate.getDate() + "." + (startDate.getMonth() + 1) + "." + startDate.getFullYear() + "-" + address + "&lock=1"} target="_blank" ><img src="/MPmedium1x_2.png" alt="Mobilepay" /></a>
                                    
                                    <hr />

                                </div>
                            </div>
                            <div className="justify-content-end d-flex">
                                <button className="btn btn-primary btn-block text-end" onClick={resetReservationDetails}>Ny reservation</button>
                            </div>
                        </tr>
                    </table>

            
                
                </div>

                

                <div hidden={window.innerWidth<700}>
                    <br /><br /><br />
                    <Steps current={wizardStep} vertical style={styles}>
                        <Steps.Item title="Vælg ledig dato" description=" " />
                        <Steps.Item title="Vælg reservation" description=" " />
                        <Steps.Item title="Bekræft reservation" description=" " />
                        <Steps.Item title="Betaling" description=" " />
                    </Steps>
                </div>
            </div>
            
        </div>
    );
};






//export default connect()(Home);



